"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_URI = "http://tiny.cc/dymo-context/";
exports.RDFS_URI = "http://www.w3.org/2000/01/rdf-schema#";
exports.EXPRESSION_ONTOLOGY_URI = "http://tiny.cc/expression-ontology#";
exports.DYMO_ONTOLOGY_URI = "http://tiny.cc/dymo-ontology#";
exports.MOBILE_AUDIO_ONTOLOGY_URI = "http://tiny.cc/mobile-audio-ontology#";
exports.TYPE = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
exports.FIRST = "http://www.w3.org/1999/02/22-rdf-syntax-ns#first";
exports.REST = "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest";
exports.NIL = "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil";
exports.VALUE = "http://www.w3.org/1999/02/22-rdf-syntax-ns#value";
exports.DOMAIN = "http://www.w3.org/2000/01/rdf-schema#domain";
exports.RANGE = "http://www.w3.org/2000/01/rdf-schema#range";
exports.LABEL = "http://www.w3.org/2000/01/rdf-schema#label";
exports.NAME = "http://schema.org/name";
exports.CDT = "http://tiny.cc/charm-ontology#cdt";
exports.ADT = "http://tiny.cc/charm-ontology#adt";
exports.HAS_PART = "http://tiny.cc/charm-ontology#hasPart";
exports.EXPRESSION = "http://tiny.cc/expression-ontology#Expression";
exports.DIRECTED = "http://tiny.cc/expression-ontology#directed";
exports.VARIABLE = "http://tiny.cc/expression-ontology#Variable";
exports.VAR_NAME = "http://tiny.cc/expression-ontology#varName";
exports.VAR_TYPE = "http://tiny.cc/expression-ontology#varType";
exports.VAR_EXPR = "http://tiny.cc/expression-ontology#varExpr";
exports.VAR_VALUE = "http://tiny.cc/expression-ontology#varValue";
exports.CONSTANT = "http://tiny.cc/expression-ontology#Constant";
exports.QUANTIFIER = "http://tiny.cc/expression-ontology#Quantifier";
exports.FOR_ALL = "http://tiny.cc/expression-ontology#ForAll";
exports.THERE_EXISTS = "http://tiny.cc/expression-ontology#ThereExists";
exports.VARS = "http://tiny.cc/expression-ontology#vars";
exports.BODY = "http://tiny.cc/expression-ontology#body";
exports.ACCESSOR = "http://tiny.cc/expression-ontology#Accessor";
exports.OBJECT = "http://tiny.cc/expression-ontology#object";
exports.PROPERTY = "http://tiny.cc/expression-ontology#property";
exports.FUNCTIONAL_TERM = "http://tiny.cc/expression-ontology#FunctionalTerm";
exports.NAMED_FUNCTION = "http://tiny.cc/expression-ontology#NamedFunction";
exports.PROPERTY_FUNCTION = "http://tiny.cc/expression-ontology#PropertyFunction";
exports.PROP = "http://tiny.cc/expression-ontology#prop";
exports.FUNCTION = "http://tiny.cc/expression-ontology#Function";
exports.FUNC = "http://tiny.cc/expression-ontology#func";
exports.ARGS = "http://tiny.cc/expression-ontology#args";
exports.CONDITIONAL = "http://tiny.cc/expression-ontology#Conditional";
exports.ANTECEDENT = "http://tiny.cc/expression-ontology#antecedent";
exports.CONSEQUENT = "http://tiny.cc/expression-ontology#consequent";
exports.ALTERNATIVE = "http://tiny.cc/expression-ontology#alternative";
exports.BINARY_OPERATOR = "http://tiny.cc/expression-ontology#BinaryOperator";
exports.LEFT = "http://tiny.cc/expression-ontology#left";
exports.RIGHT = "http://tiny.cc/expression-ontology#right";
exports.RELATIONAL_OPERATOR = "http://tiny.cc/expression-ontology#RelationalOperator";
exports.EQUAL_TO = "http://tiny.cc/expression-ontology#EqualTo";
exports.NOT_EQUAL_TO = "http://tiny.cc/expression-ontology#NotEqualTo";
exports.GREATER_THAN = "http://tiny.cc/expression-ontology#GreaterThan";
exports.LESS_THAN = "http://tiny.cc/expression-ontology#LessThan";
exports.GREATER_THAN_OR_EQUAL_TO = "http://tiny.cc/expression-ontology#GreaterThanOrEqualTo";
exports.LESS_THAN_OR_EQUAL_TO = "http://tiny.cc/expression-ontology#LessThanOrEqualTo";
exports.ARITHMETIC_OPERATOR = "http://tiny.cc/expression-ontology#ArithmeticOperator";
exports.ADDITION = "http://tiny.cc/expression-ontology#Addition";
exports.SUBTRACTION = "http://tiny.cc/expression-ontology#Subtraction";
exports.MULTIPLICATION = "http://tiny.cc/expression-ontology#Multiplication";
exports.DIVISION = "http://tiny.cc/expression-ontology#Division";
exports.POWER = "http://tiny.cc/expression-ontology#Power";
exports.DYMO = "http://tiny.cc/dymo-ontology#Dymo";
exports.DYMO_TYPE = "http://tiny.cc/dymo-ontology#DymoType";
exports.CONJUNCTION = "http://tiny.cc/dymo-ontology#Conjunction";
exports.DISJUNCTION = "http://tiny.cc/dymo-ontology#Disjunction";
exports.SEQUENCE = "http://tiny.cc/dymo-ontology#Sequence";
exports.EVENT = "http://tiny.cc/dymo-ontology#Event";
exports.FEATURE = "http://tiny.cc/dymo-ontology#Feature";
exports.PARAMETER = "http://tiny.cc/dymo-ontology#Parameter";
exports.FEATURE_TYPE = "http://tiny.cc/dymo-ontology#FeatureType";
exports.PARAMETER_TYPE = "http://tiny.cc/dymo-ontology#ParameterType";
exports.HAS_PARAMETER_TYPE = "http://tiny.cc/dymo-ontology#hasParameterType";
exports.HAS_FEATURE_TYPE = "http://tiny.cc/dymo-ontology#hasFeatureType";
exports.PARAMETER_BEHAVIOR = "http://tiny.cc/dymo-ontology#ParameterBehavior";
exports.INDEPENDENT = "http://tiny.cc/dymo-ontology#Independent";
exports.ADDITIVE = "http://tiny.cc/dymo-ontology#Additive";
exports.MULTIPLICATIVE = "http://tiny.cc/dymo-ontology#Multiplicative";
exports.ARITHMETIC_MEAN = "http://tiny.cc/dymo-ontology#ArithmeticMean";
exports.HAS_BEHAVIOR = "http://tiny.cc/dymo-ontology#hasBehavior";
exports.LEVEL_FEATURE = "http://tiny.cc/dymo-ontology#LevelFeature";
exports.INDEX_FEATURE = "http://tiny.cc/dymo-ontology#IndexFeature";
exports.ONSET_FEATURE = "http://tiny.cc/dymo-ontology#OnsetFeature";
exports.PITCH_FEATURE = "http://tiny.cc/dymo-ontology#PitchFeature";
exports.DURATION_FEATURE = "http://tiny.cc/dymo-ontology#DurationFeature";
exports.TIME_FEATURE = "http://tiny.cc/dymo-ontology#TimeFeature";
exports.SEGMENT_LABEL_FEATURE = "http://tiny.cc/dymo-ontology#SegmentLabelFeature";
exports.AUDIO_PARAMETER = "http://tiny.cc/dymo-ontology#AudioParameter";
exports.HAS_STANDARD_VALUE = "http://tiny.cc/dymo-ontology#hasStandardValue";
exports.IS_INTEGER = "http://tiny.cc/dymo-ontology#isInteger";
exports.PLAY = "http://tiny.cc/dymo-ontology#Play";
exports.LOOP = "http://tiny.cc/dymo-ontology#Loop";
exports.REPEAT = "http://tiny.cc/dymo-ontology#Repeat";
exports.ONSET = "http://tiny.cc/dymo-ontology#Onset";
exports.DURATION = "http://tiny.cc/dymo-ontology#Duration";
exports.DURATION_RATIO = "http://tiny.cc/dymo-ontology#DurationRatio";
exports.AMPLITUDE = "http://tiny.cc/dymo-ontology#Amplitude";
exports.PLAYBACK_RATE = "http://tiny.cc/dymo-ontology#PlaybackRate";
exports.TIME_STRETCH_RATIO = "http://tiny.cc/dymo-ontology#TimeStretchRatio";
exports.PAN = "http://tiny.cc/dymo-ontology#Pan";
exports.DISTANCE = "http://tiny.cc/dymo-ontology#Distance";
exports.HEIGHT = "http://tiny.cc/dymo-ontology#Height";
exports.REVERB = "http://tiny.cc/dymo-ontology#Reverb";
exports.DELAY = "http://tiny.cc/dymo-ontology#Delay";
exports.FILTER = "http://tiny.cc/dymo-ontology#Filter";
exports.STRUCTURAL_PARAMETER = "http://tiny.cc/dymo-ontology#StructuralParameter";
exports.PART_COUNT = "http://tiny.cc/dymo-ontology#PartCount";
exports.PART_DURATION_RATIO = "http://tiny.cc/dymo-ontology#PartDurationRatio";
exports.PART_PROPORTION = "http://tiny.cc/dymo-ontology#PartProportion";
exports.HAS_SOURCE = "http://tiny.cc/dymo-ontology#hasSource";
exports.HAS_PARAMETER = "http://tiny.cc/dymo-ontology#hasParameter";
exports.HAS_FEATURE = "http://tiny.cc/dymo-ontology#hasFeature";
exports.HAS_SIMILAR = "http://tiny.cc/dymo-ontology#hasSimilar";
exports.HAS_SUCCESSOR = "http://tiny.cc/dymo-ontology#hasSuccessor";
exports.HAS_FIRST = "http://tiny.cc/dymo-ontology#hasFirst";
exports.HAS_SECOND = "http://tiny.cc/dymo-ontology#hasSecond";
exports.HAS_TARGET = "http://tiny.cc/dymo-ontology#hasTarget";
exports.RENDERING = "http://tiny.cc/mobile-audio-ontology#Rendering";
exports.MOBILE_CONTROL = "http://tiny.cc/mobile-audio-ontology#MobileControl";
exports.SENSOR_CONTROL = "http://tiny.cc/mobile-audio-ontology#SensorControl";
exports.UI_CONTROL = "http://tiny.cc/mobile-audio-ontology#UiControl";
exports.DATA_CONTROL = "http://tiny.cc/mobile-audio-ontology#DataControl";
exports.AUTO_CONTROL = "http://tiny.cc/mobile-audio-ontology#AutoControl";
exports.ACCELEROMETER_X = "http://tiny.cc/mobile-audio-ontology#AccelerometerX";
exports.ACCELEROMETER_Y = "http://tiny.cc/mobile-audio-ontology#AccelerometerY";
exports.ACCELEROMETER_Z = "http://tiny.cc/mobile-audio-ontology#AccelerometerZ";
exports.TILT_X = "http://tiny.cc/mobile-audio-ontology#TiltX";
exports.TILT_Y = "http://tiny.cc/mobile-audio-ontology#TiltY";
exports.TILT_Z = "http://tiny.cc/mobile-audio-ontology#TiltZ";
exports.GEOLOCATION_LATITUDE = "http://tiny.cc/mobile-audio-ontology#GeolocationLatitude";
exports.GEOLOCATION_LONGITUDE = "http://tiny.cc/mobile-audio-ontology#GeolocationLongitude";
exports.GEOLOCATION_DISTANCE = "http://tiny.cc/mobile-audio-ontology#GeolocationDistance";
exports.COMPASS_HEADING = "http://tiny.cc/mobile-audio-ontology#CompassHeading";
exports.BEACON = "http://tiny.cc/mobile-audio-ontology#Beacon";
exports.SLIDER = "http://tiny.cc/mobile-audio-ontology#Slider";
exports.TOGGLE = "http://tiny.cc/mobile-audio-ontology#Toggle";
exports.BUTTON = "http://tiny.cc/mobile-audio-ontology#Button";
exports.CUSTOM_CONTROL = "http://tiny.cc/mobile-audio-ontology#CustomControl";
exports.RANDOM = "http://tiny.cc/mobile-audio-ontology#Random";
exports.BROWNIAN = "http://tiny.cc/mobile-audio-ontology#Brownian";
exports.RAMP = "http://tiny.cc/mobile-audio-ontology#Ramp";
exports.MOBILE_PARAMETER = "http://tiny.cc/mobile-audio-ontology#MobileParameter";
exports.GLOBAL_PARAMETER = "http://tiny.cc/mobile-audio-ontology#GlobalParameter";
exports.CONTROL_PARAMETER = "http://tiny.cc/mobile-audio-ontology#ControlParameter";
exports.LISTENER_ORIENTATION = "http://tiny.cc/mobile-audio-ontology#ListenerOrientation";
exports.AUTO_CONTROL_FREQUENCY = "http://tiny.cc/mobile-audio-ontology#AutoControlFrequency";
exports.AUTO_CONTROL_TRIGGER = "http://tiny.cc/mobile-audio-ontology#AutoControlTrigger";
exports.BROWNIAN_MAX_STEP_SIZE = "http://tiny.cc/mobile-audio-ontology#BrownianMaxStepSize";
exports.LEAPING_PROBABILITY = "http://tiny.cc/mobile-audio-ontology#LeapingProbability";
exports.CONTINUE_AFTER_LEAPING = "http://tiny.cc/mobile-audio-ontology#ContinueAfterLeaping";
exports.NAVIGATOR = "http://tiny.cc/mobile-audio-ontology#Navigator";
exports.ONE_SHOT_NAVIGATOR = "http://tiny.cc/mobile-audio-ontology#OneShotNavigator";
exports.SEQUENTIAL_NAVIGATOR = "http://tiny.cc/mobile-audio-ontology#SequentialNavigator";
exports.SIMILARITY_NAVIGATOR = "http://tiny.cc/mobile-audio-ontology#SimilarityNavigator";
exports.GRAPH_NAVIGATOR = "http://tiny.cc/mobile-audio-ontology#GraphNavigator";
exports.HAS_DYMO = "http://tiny.cc/mobile-audio-ontology#hasDymo";
exports.CONSTRAINT_OWNERS = "http://tiny.cc/mobile-audio-ontology#ConstraintOwners";
exports.CONSTRAINT = "http://tiny.cc/mobile-audio-ontology#constraint";
exports.HAS_CONTROL_PARAM = "http://tiny.cc/mobile-audio-ontology#hasControlParam";
exports.HAS_URL = "http://tiny.cc/mobile-audio-ontology#hasUrl";
exports.HAS_JSON_MAP = "http://tiny.cc/mobile-audio-ontology#hasJsonMap";
exports.IS_SMOOTH = "http://tiny.cc/mobile-audio-ontology#isSmooth";
exports.IS_AVERAGE_OF = "http://tiny.cc/mobile-audio-ontology#isAverageOf";
exports.HAS_UUID = "http://tiny.cc/mobile-audio-ontology#hasUuid";
exports.HAS_MAJOR = "http://tiny.cc/mobile-audio-ontology#hasMajor";
exports.HAS_MINOR = "http://tiny.cc/mobile-audio-ontology#hasMinor";
exports.HAS_DURATION = "http://tiny.cc/mobile-audio-ontology#hasDuration";
exports.HAS_NAVIGATOR = "http://tiny.cc/mobile-audio-ontology#hasNavigator";
exports.NAV_DYMOS = "http://tiny.cc/mobile-audio-ontology#navDymos";



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/globals/uris.js
// module id = 21
// module chunks = 3